module.exports = __webpack_public_path__ + "img/07.054e4ef0.png";